import React, { useState } from 'react';
import styles from '../landing.module.scss';
import { Link } from 'react-router-dom';
import mainlogo from "../../../assets/images/new_web_logo.png";
import wowinxLogo from "../../../assets/images/wowinx-logo.avif";
import axios from 'axios';
import { triggerToast } from '../../../utils/toast';
import { blogApiUrl } from '../../../utils/variables';

const Footer = () => {
    const [email, setEmail] = useState('');
    const [subscribed, setSubscribed] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubscribe = async (e) => {
        e.preventDefault();
        if (!email.trim()) return;
        
        setLoading(true);
        
        try {
            const response = await axios.post(`${blogApiUrl}/newsletter/subscribe`, {
                email: email.trim()
            });
            
            if (response.status === 201 || response.status === 200) {
                setSubscribed(true);
                triggerToast(response.data.message || 'Successfully subscribed to the newsletter!', 'success');
                setEmail('');
                setTimeout(() => {
                    setSubscribed(false);
                }, 5000);
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Something went wrong. Please try again.';
            triggerToast(errorMessage, 'error');
        } finally {
            setLoading(false);
        }
    };

    const footerLinks = [
        // { label: 'Daily Insight', href: '/' },
        { label: 'App Tracking', href: '/app-tracking' },
        { label: 'Keyword Tracking', href: '/keyword-tracking' },
        { label: 'Blog', href: '/blog' },
        { label: 'Publisher Explorer', href: '/publisher-analysis' },
        { label: 'AI Chat', href: '/chatbot' },
        { label: 'Contact Us', href: '/contact-us' },
    ];

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                {/* Main Footer Content */}
                <div className={styles.footerGrid}>
                    {/* Block 1: KeyQuest Info */}
                    <div className={styles.footerBlock}>
                        <Link to="/" className={styles.footerLogoBlock}>
                            <img
                                src={mainlogo}
                                alt="KeyQuest home"
                                loading="lazy"
                                className={styles.footerLogoImg}
                            />
                        </Link>
                        <p className={styles.footerDescription}>
                            KeyQuest is an AI-powered XR app analytics platform that delivers daily insights, keyword tracking, and market research to help you grow your app organically.
                        </p>
                        <div className={styles.poweredByBlock}>
                            <span className={styles.partOfText}>A part of</span>
                            <a
                                href="https://wowinx.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.wowinxLinkBlock}
                            >
                                <img
                                    src={wowinxLogo}
                                    alt="WowinX"
                                    className={styles.wowinxLogoImg}
                                />
                            </a>
                        </div>
                    </div>

                    {/* Block 2: Links & Resources */}
                    <div className={styles.footerBlock}>
                        <h3 className={styles.footerBlockTitle}>Links & Resources</h3>
                        <ul className={styles.footerLinksList}>
                            {footerLinks.map((link) => (
                                <li key={link.label}>
                                    <Link to={link.href} className={styles.footerLink}>
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Block 3: Stay Updated / Newsletter */}
                    <div className={styles.footerBlock}>
                        <h3 className={styles.footerBlockTitle}>Stay Updated</h3>
                        <p className={styles.footerDescription}>
                            Subscribe to our newsletter for the latest insights and product updates.
                        </p>
                        <form onSubmit={handleSubscribe} className={styles.newsletterForm}>
                            <input
                                type="email"
                                placeholder="your@email.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className={styles.newsletterInput}
                                required
                                disabled={loading}
                            />
                            <button type="submit" className={styles.newsletterButton} disabled={loading}>
                                {loading ? '...' : subscribed ? '✓' : '→'}
                            </button>
                        </form>
                        <p className={styles.disclaimerText}>
                            By subscribing, you agree to our Privacy Policy and Terms of Service.
                        </p>
                    </div>
                </div>

                {/* Footer Divider */}
                <div className={styles.footerDivider}></div>

                {/* Footer Bottom */}
                <div className={styles.footerBottom}>
                    <span className={styles.copyright}>© 2026 KeyQuest. All Rights Reserved.</span>
                    <div className={styles.footerLegalLinks}>
                        <Link to="/privacy" className={styles.legalLink}>Privacy Policy</Link>
                        <Link to="/terms" className={styles.legalLink}>Terms of Service</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
